/* *************************
 * 	hover actions
 * ************************* */
var hoverActions = {
	init:function(){
	    $('.hover-add-class').mouseenter(function(e) {
	    	var target = $(e.currentTarget);
	    	var css_selector = target.data('hv-selector');
	    	var css_class = target.data('hv-class');
	    	if (typeof(css_selector) == 'undefined' || css_selector == '') css_selector = e.currentTarget;
	    	$(css_selector).addClass(css_class);
	    }).mouseleave(function(e) {
	    	var target = $(e.currentTarget);
	    	var css_selector = target.data('hv-selector');
	    	var css_class = target.data('hv-class');
	    	if (typeof(css_selector) == 'undefined' || css_selector == '') css_selector = e.currentTarget;
	    	$(css_selector).removeClass(css_class);
	    });
	}
};

$(document).ready(function() {
	hoverActions.init();
});

/* *************************
 * 	slick slider functions
 * ************************* */

/*
	slickPagingInfo
	Example:
	<div class="gallerySlider" data-paging=".gallery-paging-info">...</div>
	<div class="gallery-paging-info"></div>
	slickPagingInfo.init('.gallerySlider', ' | ');
 */
window.slickPagingInfo = {
	init:function(selector){
		var $this = this,
			pagingSelector = $(selector).data('paging'),
			divider = $(selector).data('divider'),
			progressSelector = $(selector).data('progress'),
			numlength = $(selector).data('numlength');
		// paging
		if (typeof pagingSelector != 'undefined') {
			if (typeof divider == 'undefined') divider = ' | ';
	        $(selector).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	            var i = (currentSlide ? currentSlide : 0) + 1;
				var pagingSelector = $(selector).data('paging');
	            $this.set(selector, pagingSelector, i, divider, numlength);
	        });
	        $this.set(selector, pagingSelector, 1, divider, numlength);
		}
		// progress
		if (typeof progressSelector != 'undefined') {
			var $slider = $(selector).first();
			$slider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {   
	            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	            var i = (currentSlide ? currentSlide : 0) + 1;
				var progressSelector = $(selector).data('progress');
				$this.setProgress(selector, progressSelector, i, numlength);
			});
			$this.setProgress(selector, progressSelector, 1, numlength);
		}
	},
	
	set:function(selector, pagingSelector, currentSlide, divider, numlength){
		$(pagingSelector).html(this.pad(currentSlide,numlength) + '<span class="font-h">' + divider + this.pad($(selector).slick('getSlick').slideCount,numlength) + '</span>');
	},
	setProgress:function(selector, progressSelector, currentSlide, numlength){
		var slideCount = $(selector).first().slick('getSlick').slideCount;
		var calc = ( (currentSlide) / (slideCount) ) * 100;
		var $progressBar = $(progressSelector).first();
		$progressBar
	      .css('background-size', calc + '% 2px')
	      .attr('aria-valuenow', calc );
		$progressBar.html('<div class="progressno">' + currentSlide + '</div><div class="progresscount">' + slideCount + '</div>');
	},
	pad:function(num, size) {
		if (typeof size == 'undefined') return num;
	    num = num.toString();
	    while (num.length < size) num = "0" + num;
	    return num;
	}
}

/* *******************
 * Comfortcontact
 * ****************** */
function showComfortcontact(){
	$('.comfortcontact-box').addClass('show-box');
	$('BODY').addClass('comfortcontact-open');
}
function hideComfortcontact(){
	$('.comfortcontact-box').removeClass('show-box');
	$('BODY').removeClass('comfortcontact-open');
}


$(document).ready(function () {
    const $btn = $(".btn-comfortcontact");
    const $box = $(".comfortcontact-box"); // Stelle sicher, dass die Box diese Klasse hat
    const $body = $("body");

    // Hilfsfunktion zum Prüfen, ob die Maus über Button oder Box schwebt
    function isMouseOverInteractive() {
        return $btn.is(':hover') || $(".comfortcontact-box:hover").length > 0;
    }

    // HOVER Logik
    $btn.add(".comfortcontact-box").hover(
        function() {
            showComfortcontact($btn[0]);
        },
        function() {
            // Kurze Verzögerung, um den Wechsel zwischen Button und Box zu überbrücken
            setTimeout(function() {
                if (!isMouseOverInteractive() && !$btn.hasClass('is-clicked')) {
                    hideComfortcontact();
                }
            }, 50);
        }
    );

    // CLICK (Toggle) Logik
    $btn.on("click", function(e) {
        e.stopPropagation();
        
        if ($btn.hasClass('is-clicked')) {
            closeAll();
        } else {
            $btn.addClass('is-clicked');
            showComfortcontact(this);
            
            // Globaler Klick-Aussen-Handler
            $(document).on("click.hideDocClick", function(event) {
                if (!$(event.target).closest('.btn-comfortcontact, .comfortcontact-box').length) {
                    closeAll();
                }
            });
        }
    });

    function closeAll() {
        $btn.removeClass('is-clicked');
        hideComfortcontact();
        $(document).off(".hideDocClick");
    }
});


// SwitchHeader — Einfacher Wechsel von Header-Zuständen beim Scrollen
// Nutzung:
// 1) Ziel-Element anlegen, z. B. <div id="switchheader"></div>
// 2) Modul initialisieren:
//    switchHeader.init({
//      selector: '#switchheader',
//		switchPosition:'300',
//      before: () => document.querySelector('.header-bgcontainer').classList.add('bg-secondary'),
//      after:  () => document.querySelector('.header-bgcontainer').classList.remove('bg-secondary'),
//      debounceMs: 60 // optional, Standard: 80
//    });
//    - before wird ausgeführt, wenn das Fenster die Position des Elements erreicht oder überschreitet.
//    - after wird ausgeführt, wenn das Fenster wieder oberhalb der Position ist.
//    - Existiert das Element nicht, wird before sofort ausgeführt (wie im Original).
// 3) Optionale Methoden:
//    switchHeader.trigger()           // manueller Check
//    switchHeader.setSelector('#id')  // Selector ändern

window.switchHeader = (function () {
  const noop = () => {};

  function debounce(fn, wait = 0) {
    let t = null;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  let selector = '#switchheader';
  let onBefore = noop;
  let onAfter = noop;
  let lastState = null;
  let element = null;
  let switchPosition = null;
 
  function updateElement() {
    element = document.querySelector(selector);
  }

  function getOffsetTop(el) {
    if (!el) return Infinity;
    const rect = el.getBoundingClientRect();
    return rect.top + window.pageYOffset;
  }

  function check() {
    const elTop = getOffsetTop(element);
	const threshold = switchPosition !== null ? switchPosition : elTop;
	const scrolledPast = window.pageYOffset >= threshold;

    if (scrolledPast === lastState) return;
    lastState = scrolledPast;

    if (scrolledPast) onAfter();
    	else onBefore();
  }

  return {
    init({ selector: sel = '#switchheader', before = noop, after = noop, debounceMs = 80, switchPosition: pos } = {}) {
      selector = sel;
      onBefore = typeof before === 'function' ? before : noop;
      onAfter = typeof after === 'function' ? after : noop;
	  switchPosition = pos !== undefined ? pos : null;
      updateElement();

      if (!element && switchPosition === null) {
        return;
      }

      check();
      const handler = debounce(check, debounceMs);
      window.addEventListener('scroll', handler, { passive: true });
      window.addEventListener('resize', () => {
        updateElement();
        handler();
      }, { passive: true });
    },
    trigger() { check(); },
    setSelector(sel) { selector = sel; updateElement(); }
  };
})();
/* *************************
 * 	nav
 * ************************* */
window.nav = {
	dropdown : $("#mainnav .navbar-nav > .dropdown"),
	dropdownDropdown : $("#mainnav .navbar-nav .dropdown .dropdown > .dropdown-item"),
	dropdownToggle : $(".dropdown-toggle"),
	dropdownMenu : $(".dropdown-menu"),
	showClass : "show",
	navMobiledDdClass : '.mobile-dd-toggle',
	navMobileBreakpoint:0,
	init:function(){
		nav.dropdown.hover(
	      function() {
			if ($(window).width() > nav.navMobileBreakpoint) nav.openHoverMenu(this);
	      },
	      function() {
	  		if ($(window).width() > nav.navMobileBreakpoint) nav.closeHoverMenu();
	      }
	    );

		nav.dropdownDropdown.click(
	      function(e) {
	        var $this = $(this).closest('.dropdown');
	        var action = 'open';
	        if ($this.hasClass(nav.showClass)) action = 'close';
	    	nav.closeClickMenu();
	    	if (action == 'open') {
		        $this.addClass(nav.showClass);
		        $this.children(nav.dropdownMenu).addClass(nav.showClass);
	    	}
	    	e.stopPropagation();
	        e.preventDefault();
	      }

	    );
		$(document).on("click", ".nav-toggle", function(event){
			event.stopPropagation();
			event.preventDefault();
			if (event.target.hasAttribute('data-navid')) {
				nav.openHoverMenu(document.getElementById($(event.target).attr('data-navid')));
			}
		});
		/* mobile-dd-toggle */
		$("#mainnav " + nav.navMobiledDdClass).click(nav.switchMobileDdToggle);
        $("#mainnav " + nav.navMobiledDdClass).keydown(function(e) {
	        if (e.key === "Enter") nav.switchMobileDdToggle(e);
        });
	},
	switchMobileDdToggle:function(e) {
			if ($(e.currentTarget).attr("aria-expanded") == 'false') {
		        nav.openMenu($(e.currentTarget).closest('.dropdown'));
			} else {
		        nav.closeMenu($(e.currentTarget).closest('.dropdown'));
			}
	    	e.stopPropagation();
	        e.preventDefault();
	},
	openMenu:function(e){
		var $this = $(e);
	    $this.addClass(nav.showClass);
	    $this.children(nav.dropdownToggle).attr("aria-expanded", "true");
	    $this.children(nav.dropdownMenu).addClass(nav.showClass);
		$this.children(nav.dropdownToggle).children(nav.navMobiledDdClass).attr("aria-expanded", "true");
	},
	closeMenu:function(e){
		if (e) {
	    	var $this = e;			
		} else {
	    	var $this = $(nav.dropdown);
		}
        $this.removeClass(nav.showClass);
        $this.children(nav.dropdownToggle).attr("aria-expanded", "false");
        $this.children(nav.dropdownMenu).removeClass(nav.showClass);

		$this.find(nav.navMobiledDdClass).first().attr("aria-expanded", "false");
			
	},
	openHoverMenu:function(e){
		nav.closeHoverMenu();
		nav.openMenu(e);
	},
	closeHoverMenu:function(e){
		nav.closeMenu($(nav.dropdown));			
	},
	closeClickMenu:function(){
        var $this = $(nav.dropdown + " .dropdown");
        $this.removeClass(nav.showClass);
        $this.children(nav.dropdownMenu).removeClass(nav.showClass);
	}
};

/**
 * SmoothScrollHandler
 * 
 * Verwendung:
 * const scrollHandler = new SmoothScrollHandler({ 
 *    offset: 140,            // Standard Offset für normale Anker
 *    accordionOffset: 100,   // Spezieller Offset für Accordion-Elemente
 *    speed: 600              // Animationsgeschwindigkeit in ms
 * });
 * 
 * Voraussetzung: jQuery und Bootstrap JS müssen geladen sein.
 */
class BootstrapScrollHandler {
    constructor(options = {}) {
        // Zwei verschiedene Offsets konfigurierbar
        this.defaultOffset = options.offset || 140;
        this.accordionOffset = options.accordionOffset || 90; 
        this.speed = options.speed || 600;
        
        // CSS Smooth Scroll deaktivieren für volle JS-Kontrolle
        $('html').css('scroll-behavior', 'auto !important');
        
        this.init();
    }

    init() {
        // 1. Initialer Check (Deep Link)
        $(window).on('load', () => {
            if (window.location.hash) {
                window.scrollTo(0, 0); 
                setTimeout(() => this.handleTarget(window.location.hash), 100);
            }
        });

        // 2. Klick-Handler
        $(document).on('click', 'a[href*="#"]', (e) => {
            const link = e.currentTarget;
            if (link.pathname === window.location.pathname && link.hash) {
                e.preventDefault();
                e.stopImmediatePropagation();
                
                this.handleTarget(link.hash);
                history.pushState(null, null, link.hash);
            }
        });
    }

    handleTarget(hash) {
        const $target = $(hash);
        if (!$target.length) return;

        // Fallunterscheidung: Accordion vs. normaler Anker
        const isAccordion = $target.hasClass('collapse') || $target.hasClass('accordion-collapse');
        const currentOffset = isAccordion ? this.accordionOffset : this.defaultOffset;

        if (isAccordion) {
            if ($target.hasClass('show')) {
                this.scrollToElement($target, currentOffset);
            } else {
                // Erst scrollen, wenn Bootstrap fertig ausgeklappt hat (verhindert Ruckeln)
                $target.one('shown.bs.collapse', () => {
                    this.scrollToElement($target, currentOffset);
                });
                $target.collapse('show');
            }
        } else {
            this.scrollToElement($target, currentOffset);
        }
    }

    scrollToElement($element, offsetValue) {
        // Position erst bei Funktionsaufruf messen (wichtig nach dem Aufklappen!)
        const targetPos = $element.offset().top - offsetValue;

        $('html, body').stop(true).animate({
            scrollTop: targetPos
        }, this.speed, 'swing');
    }
}
window.BootstrapScrollHandler = BootstrapScrollHandler;